import { Database, Layers, Box, Calendar, FileCode } from 'lucide-react';

export function getPipelineNodeIcon(nodeType: string, className: string = 'h-4 w-4 text-muted-foreground') {
  switch (nodeType) {
    case 'SOURCE':
    case 'SOURCE_FILE':
    case 'SEED_SOURCE':
      return <Database className={className} />;
    case 'CUSTOM':
      return <FileCode className={className} />;
    case 'DIMENSION':
      return <Box className={className} />;
    case 'DATE_DIMENSION':
      return <Calendar className={className} />;
    case 'STAGING':
    default:
      return <Layers className={className} />;
  }
}
